export default {
  common: {
    label_fr:"francais",
    label_en:"english",
    label_es:"spanish",
    labelActions55:"Actions 5•5",
    labelCollections55:"Collections 5•5",
    labelClassics:"Classiques",
    labelCreateYourModel: "Créer mon modèle",
    labelPreviousProject: "Projet précédent",
    labelNextProject:"Projet suivant",
    footerLegals:"Mentions légales",
    footerOberSurfacesBrand:"Une marque Ober Surfaces",
    footerPageOnTop:"Haut de page",
    LabelOpenProject:"Voir le projet",
    realisationsBackbutton:"Retour aux Réalisations",
    labelArchitect:"Architecte",
    labelDesign:"Design",
    labelPattern:"Motif",
    labelSurface:"Surface",
    cancelButton: "Annuler",
    submitButton: "Valider",
    createButton: "Créer",
    saveButton: "Enregistrer",
    deleteButton: "Supprimer",
    continueButton: "Continuer",
    newFolder: "Nouveau dossier"



  },
  layout: {
    myaccount: "Mon compte",
    mymodels: "Mes modèles",
  },
  menu: {
    menuCreate:"Créer un modèle",
    menuAbout:"A propos",
    menuCollections:"Collections",
    menuRealisations:"Réalisations",
    menuContact:"Contact",
    menuSupport:"F.A.Q"
  },
  header: {
  },
  footer: {
    newProjectLabel: "Nouveau dossier"
  },
  realisations: {
    internationalInstitution:"Institution Internationale",
    ministryOfForeignAffairs:"Ministère des Affaires Etrangères"
  },
  collections: {
    titleSurfaces: "Les Surfaces",
    titlePatterns: "Les Motifs",
  },
  collectionsList: {
    titleSurfaces: "Les Surfaces",
    titlePatterns: "Les Motifs",
    pageintroduction1: "Découvrez l’ensemble des collections",
    pageintroduction2: "sur les sites de nos marques",
    oberflexDescription: "L’élégance du bois véritable associé à la haute résistance de surface Oberflex; une technicité incomparable pour une utilisation dans les projets les plus exigeants.",
    marotteDescription: "Placages de bois teintés dans la masse pour sublimer l’intensité des couleurs et la finesse des veinages.",
    purepaperColorDescription: "Une collection de surfaces décoratives riche de 25 couleurs soigneusement sélectionnées, extra mates et d’une grande profondeur semblable à celle du papier buvard.",
    purepaperMetalDescription: "Les tonalités de cuivre, inox, étain, laiton, alu, ou encore canon de fusil composent une palette de 11 surfaces métalliques aux aspects brossés, brillants ou bruts de laminage."
  },
  patternsList: {
    titleSurfaces: "Les Surfaces",
    titlePatterns: "Les Motifs",
    action55Description: "La nouvelle collection de panneaux acoustiques personnalisables, 6 modèles à configurer pour donner naissance à une infinité de motifs perforés.",
    collections55Description: "Cinq collections imaginées par Studio 5•5 regroupant chacune cinq motifs qui deviennent peau d’architecture, vêtement d’espace, mur végétal, panneau vibrant ou véritable paysage.",
    classicsDescription: "La collection des basiques pour une intégration discrète. Des perforations rondes, oblongues ou invisibles avec la technologie de micro-perforation.",
    discoverbutton:"Découvrir la gamme",

  },
  about: {
    pageDescription1:"Obersound est un concept de panneaux acoustiques imaginé",
    pageDescription2:"et développé par le Studio collectif 5.5 pour Ober Surfaces,",
    pageDescription3:"fabricant de solutions décoratives et techniques pour l'agencement intérieur.",
    obersurfacesDescription1:"Animé par des valeurs d’innovation et d’éco-conception, Ober Surfaces propose à travers les marques Oberflex, Marotte, Pure Paper et Staron, un vaste choix de surfaces décoratives pour l’agencement intérieur. L’entreprise cultive sa capacité à réagir au plus près de la demande, elle anticipe constamment le désir de nouveautés et met tout en œuvre pour satisfaire aux exigences de la création.",
    obersurfacesDescription2:"Ce dynamisme créatif amène également Ober Surfaces à se tourner vers des partenariats extérieurs et à créer des collections en collaboration avec des architectes et designers. Cette démarche se prolonge aujourd’hui par l’intervention du studio 5.5 afin d’imaginer de nouvelles modalités de perforations acoustiques.",
    obersurfacesDescription3:"L’ensemble des solutions esthétiques, techniques et acoustiques sont à retrouver sur ober-surfaces.com",
    studio55Description1:"5•5 est un studio collectif de design global fondé en août 2003 par Vincent Baranger, Jean-Sébastien Blanc, Anthony Lebossé et Claire Renard après des études à l'Ecole Nationale Supérieure des Arts Appliqués.",
    studio55Description2:"Aujourd'hui, leur petit collectif est devenu un studio mais n'a pas pour autant changé d'état d'esprit. Prônant depuis sa création, la collaboration d'individus dans un esprit joyeux, le studio 5•5 rassemble naturellement des talents créatifs pluridisciplinaires dans une démarche de design global. Les 5•5 animent désormais une structure capable d'accompagner leurs clients avec les mêmes convictions qu'à leurs débuts : rester toujours proche des gens, en proposant des choses utiles et aspirationnelles pour le plus grand nombre dans un souci d'égayer notre quotidien.",
  },
  support: {
    titleTechnicalQuestion:"Questions techniques",
    titleBusinessQuestion:"Questions commerciales",
    titleAcousticQuestion:"Questions acoustiques"
  },
  supportTechnical: {

    question1:"A quoi sont destinés les panneaux Obersound\u00a0?",
    boldWords1:"panneaux Obersound",
    answer1:"Les panneaux Obersound sont destinés à améliorer le confort acoustique d’un espace intérieur. Installés aux murs ou aux plafonds, Ils absorbent une partie de l’onde sonore et limite sa réverbération.",

    question2:"Quelle est la composition d’un panneau Obersound\u00a0?",
    boldWords2:"composition",
    answer2:"Le panneau Obersound est composé d’une âme (panneau support) en MDF, revêtue d’une surface décorative en bois, en couleur unie ou en métal, et d’une contre face d’équilibrage. Une fois perforé, l’arrière du panneau Obersound est opacifié par un voile noir.",

    question3:"Quels sont les formats de panneaux Obersound\u00a0?",
    boldWords3:"formats",
    answer3:"Les panneaux Obersound sont disponibles en formats standards de 2500 x 1200 mm ou 3000 x 1200 m. Ils peuvent également être fabriqués sur mesure, selon un plan et une fiche de débit à fournir.",

    question4:"Comment sont traités les chants des panneaux Obersound\u00a0?",
    boldWords4:"chants des panneaux",
    answer4:"Les chants (côtés) des panneaux Obersound peuvent être bruts (MDF Noir), ou revêtus d’une surface coordonnée à la face.",

    question5:"Comment installer un panneau Obersound\u00a0?",
    boldWords5:"installer",
    answer5:"Les techniques de mises en œuvre des panneaux Obersound sont identiques à celles utilisées pour les panneaux d’agencement traditionnel. Un menuisier ou un agenceur qualifié choisira le système de fixation adapté aux particularités du lieu concerné (clés, profils, etc.). Pour une absorption acoustique optimale, il prévoira la mise en place d’une couche de laine de roche à l’arrière des panneaux.",

    question6:"Est-il possible d’utiliser le modèle que j’ai configuré en plafond\u00a0?",
    boldWords6:"plafond",
    answer6:"Les panneaux acoustiques Obersound ont vocation à être agencés aux murs et/ou aux plafonds. Le service client Ober Surfaces peut vous conseiller sur les formats les plus adaptés et sur le mode de pose à prévoir en fonction des contraintes techniques propres à chaque projet.",

    question7:"Est-ce possible de compléter mon agencement acoustique avec des panneaux de la même finition mais sans perforation\u00a0?",
    boldWords7:"panneaux",
    boldWords7_1:"sans perforation",
    answer7:"Indispensables pour compléter un agencement (portes et encadrement de portes, plinthes, cimaises, ...) les panneaux non perforés sont disponibles dans toutes les surfaces proposées par le configurateur Obersound. Dans le but de garantir une bonne homogénéité entre les panneaux, il est conseillé de tout commander en même temps.",

    question8:"A qui dois-je m’adresser pour réaliser l’étude acoustique de mon projet\u00a0?",
    boldWords8:"l’étude acoustique",
    answer8:"C’est l’architecte, le plus souvent accompagné d’un acousticien, qui effectue les recommandations acoustiques du projet.",

    question9:"Les formats de panneaux standards ne sont pas adaptés à mon projet. Ils vont générer trop de chutes. Comment puis-je faire\u00a0?",
    boldWords9:"formats de panneaux standards",
    answer9:"Tout au long du processus de mise au point du projet, le service client Ober Surfaces peut étudier vos plans et proposer des solutions adaptées : panneaux sur mesure, aménagements de votre calepinage, etc.",

  },
  supportBusiness: {
    question1:"Comment connaitre le prix d’un modèle que j’ai configuré\u00a0?",
    boldWords1:"prix",
    answer1:"Le service client Ober Surfaces est à la disposition de votre menuisier pour lui transmettre une étude de prix correspondant au modèle de panneau configuré. Le prix/m2 des panneaux Obersound varie principalement en fonction du type de surface décorative et de la perforation.",

    question2:"Quel est le délai de fabrication des panneaux Obersound\u00a0?",
    boldWords2:"délai",
    answer2:"Chaque panneau Obersound est unique et fabriqué spécialement selon les options proposées par le configurateur. Le délai de fabrication habituel est de 4 à 5 semaines sauf cas particuliers.",

    question3:"Je suis menuisier ou installateur, quelles informations dois-je fournir pour obtenir un devis\u00a0?",
    boldWords3:"informations",
    answer3:"Le Service Client Ober Surfaces étudie une offre de prix sur la base de la fiche technique du produit configuré, des dimensions et des quantités souhaitées. Il peut vous recommander d’éventuelles options telles que des usinages de chants, classement au feu, des profilés d’installation, etc.",

    question4:"Est-ce possible de compléter mon agencement acoustique avec des panneaux de la même finition mais sans perforation\u00a0?",
    boldWords4:"panneaux",
    boldWords4_1:"sans perforation",
    answer4:"Indispensables pour compléter un agencement (portes et encadrement de portes, plinthes, cimaises, ...) les panneaux non perforés sont disponibles dans toutes les surfaces proposées par le configurateur Obersound. Dans le but de garantir une bonne homogénéité entre les panneaux, il est conseillé de tout commander en même temps.",

    question5:"A qui dois-je m’adresser pour réaliser l’étude acoustique de mon projet\u00a0?",
    boldWords5:"l’étude acoustique",
    answer5:"C’est l’architecte, le plus souvent accompagné d’un acousticien, qui effectue les recommandations acoustiques du projet.",

    question6:"J’ai besoin de soumettre à mon client un prototype du modèle configuré. Est-ce possible\u00a0?",
    boldWords6:"prototype du modèle configuré",
    answer6:"Oui. Il suffit de vous adresser au service client Ober Surfaces pour recevoir un devis de fabrication du prototype.",

    question7:"Est-ce possible de commander un échantillon de la surface choisie pour le panneau que j’ai configuré\u00a0?",
    boldWords7:"échantillon",
    answer7:"Oui, sur simple demande auprès du service client Ober Surfaces.",

    question8:"Les formats de panneaux standards ne sont pas adaptés à mon projet. Ils vont générer trop de chutes. Comment puis-je faire\u00a0?",
    boldWords8:"formats de panneaux standards",
    answer8:"Tout au long du processus de mise au point du projet, le service client Ober Surfaces peut étudier vos plans et proposer des solutions adaptées : panneaux sur mesure, aménagements de votre calepinage, etc."
    },

  supportAcoustic: {
    question1:"Comment interpréter les données acoustiques disponibles sur le configurateur Obersound\u00a0?",
    boldWords1:"données acoustiques",
    answer1:"La bonne gestion de l’acoustique d’un espace ne passe pas obligatoirement par une absorption maximum. La courbe illustre le niveau d’absorption en fonction des fréquences.",

    question2:"Faut-il toujours privilégier les modèles Obersound les plus absorbants\u00a0?",
    boldWords2:"plus absorbants",
    answer2:"L’évaluation du niveau d’absorption le plus adapté à un espace se fait selon plusieurs critères comme la fonction du lieu (hall d’accueil, salle de restaurant, bureaux, ...) sa configuration ou la prise en compte d’autres matériaux absorbants (moquette, tissu, mobilier, etc.).",

    question3:"A qui dois-je m’adresser pour réaliser l’étude acoustique de mon projet\u00a0?",
    boldWords3:"l’étude acoustique",
    answer3:"C’est l’architecte, le plus souvent accompagné d’un acousticien, qui effectue les recommandations acoustiques du projet."
    },

  home: {
    page2Action55Description: "La nouvelle collection de panneaux acoustiques personnalisables",
    page3Description: "6 modèles à configurer pour donner naissance à une infinité de motifs perforés",
    page4Description: "Un nouvel outil pour explorer l’ensemble des solutions acoustiques Obersound à combiner avec les collections Ober surfaces®",
    page4Step1Title:"Créez vos modèles à l’aide du configurateur",
    page4Step1Description:"Choississez vos motifs et combinez les à plus de 160 surfaces différentes",
    page4Step2Title:"Constituez votre matériauthèque",
    page4Step2Description:"Organisez vos créations dans une bibliothèque personnelle.",
    page4Step3Title:"Téléchargez vos modèles & fiches techniques",
    page4Step3Description:"Télécharger les images HD et des informations techniques",
    page5Title:"Commencez votre expérience et retrouvez toutes les solutions Obersound",
    page5Pattern1Description:"La nouvelle collection de panneaux acoustiques personnalisables, 6 modèles à configurer pour donner naissance à une infinité de motifs perforés.",
    page5Pattern2Description:"Cinq collections imaginées par le studio 5•5 regroupant chacune cinq motifs qui deviennent peau d’architecture, vêtement d’espace, mur végétal, panneau vibrant ou véritable paysage.",
    page5Pattern3Description:"La collection des basiques pour une intégration discrète. Des perforations rondes, oblongues ou invisibles avec la technologie de micro-perforation.",
  },
  terms: {
    titleTerms:"Mentions légales",
    textTerms:"L’accès, l’utilisation et la connexion à ce site impliquent l’acceptation intégrale et sans réserve des présentes modalités d’utilisation.",
    title1:"1. Informations légales",
    text1_1:"Le site www.obersound.com que vous consultez actuellement est la propriété de :",
    text1_2:"OBER&lt;br/&gt;31 rue de Bar, 55000 Longeville en Barrois&lt;br/&gt;France&lt;br/&gt;T : +33 3 29 76 77 78&lt;br/&gt;obercom@ober-surfaces.com&lt;br/&gt;&lt;br/&gt;SA au capital de 2 061 509 €&lt;br/&gt;R.C. Bar le Duc B 382 745 404&lt;br/&gt;N° TVA intracommunautaire : FR 82 382 745 404&lt;br/&gt;",
    text1_3:"Directeur de la publication : Etienne de la Thébeaudière &lt;br/&gt;Ce site est hébergé par Firebase, 188 King ST, San Francisco, CA 94107,United States, https ://firebase.google.com/. &lt;br/&gt;Ce site a été conçu par le studio 5&#8226;5, 8 rue Popincourt 75011 PARIS,France&lt;br/&gt;Ce site a été développé par la société Sensology, 21 rue Trévise 75009 PARIS, France&lt;br/&gt;",
    title2:"2. Données personnelles",
    text2_1:"Nous recueillons des données personnelles parmi les informations sollicitées lorsque vous vous connectez à votre compte.",
    text2_2:"Les informations que nous recueillons peuvent être utilisées pour :&lt;br/&gt;- Répondre à vos demandes dans le cadre des relations commerciales entre vous et notre société Ober&lt;br/&gt;- Améliorer notre site web&lt;br/&gt;- Vous contacter par e-mail ou téléphone&lt;br/&gt;- Vous informer de notre actualité par newsletters",
    text2_3:"En vertu des dispositions du Règlement (UE) du Parlement Européen et du Conseil sur la Protection des Données N°2016/679, en date du 27 avril 2016 (« RGPD »), vous pouvez exercer vos droits d’accès, de rectification, d’annulation/suppression, d’opposition, de limitation ou de portabilité à l’adresse e-mail suivante : obercom@ober-surfaces.com",
    text2_4:"Ober s'engage expressément à ne pas divulguer ces informations à des tiers.",
    title3:"3. Cookies",
    text3_1:"Les cookies sont de petits fichiers textes qui sont installés sur votre ordinateur ou votre périphérique lorsque vous visitez notre site, afin de rendre vos visites plus efficaces. Ils nous permettent également d’améliorer la navigation.",
    text3_2:"Nous utilisons des cookies pour :&lt;br/&gt;- Mémoriser vos informations de connexion&lt;br/&gt;- Vous identifier lorsque vous vous connectez à notre site&lt;br/&gt;- Collecter des informations analytiques pour, par exemple, compter le nombre de visiteurs sur notre site et identifier les pages les plus fréquemment visitées",
    title4:"4. Propriété intellectuelle",
    text4_1:"L'accès au site www.obersound.com vous confère un droit d'usage privé et non exclusif de ce site.",
    text4_2:"Tous les articles, photographies et autres documents sur ce site sont la propriété de Ober, ou sont utilisés avec le consentement de leurs propriétaires, et sont assujettis aux droits d'auteurs et autres droits de propriété intellectuelle. Toute reproduction et / ou représentation totale ou partielle des contenus figurant sur ce site est interdite sans l’autorisation préalable, expresse et par écrit d’Ober.",
    text4_3:"L'utilisation frauduleuse de tout contenu du site www.obersound.com est totalement interdite. Ober vous informe qu'il usera largement de ses droits de propriété intellectuelle pour engager des poursuites, mêmes pénales, si nécessaire.",
    title5:"5. Conditions d’utilisation",
    text5_1:"La société Ober s’efforce d’assurer l’exactitude et de maintenir une mise à jour constante des informations diffusées sur ce site. Elle se réserve le droit de corriger ou de modifier son contenu à tout moment et sans préavis.",
    text5_2:"Les informations contenues dans ce site (fiches techniques, illustrations, images ou tous autres éléments) ne sont pas contractuelles.",
    text5_3:"Ober s'engage à faire ses meilleurs efforts pour assurer aux utilisateurs une accessibilité du site à tout moment. Ober ne pourra être tenu responsable, en cas d'indisponibilité du site, pour quelque cause que ce soit.",
    title6:"6. Limites de responsabilité",
    text6_1:"Vous utilisez et naviguez sur ce site ce site sous votre responsabilité exclusive. Ni Ober ni aucun tiers impliqué dans la création, la production ou la mise en œuvre de ce site ne pourront être tenus pour responsables des dommages directs, indirects, accidentels, consécutifs ou autres qui résulteraient de votre accès à ce site ou de son utilisation, y compris, et sans restriction, les pertes d’exploitation, les pertes de données ou l’interruption d’activités.",
    text6_2:"De même, Ober ne pourra pas être tenue pour responsable des dommages qui pourraient être causés ou des virus qui pourraient infecter votre équipement informatique ou tout autre matériel, ni des pertes ou des altérations de données suite à votre accès à ce site ou aux téléchargements réalisés sur ce site. En aucun cas la responsabilité globale d’Ober, quel qu’en soit le fondement, ne pourra dépasser le montant que vous aurez versé pour accéder à ce site.",
    text6_3:"Ober s'engage à faire ses meilleurs efforts pour assurer aux utilisateurs une accessibilité du site à tout moment. Ober ne pourra être tenu responsable, en cas d'indisponibilité du site, pour quelque cause que ce soit.",
    title7:"7. Contact",
    text7_1:"Pour nous contacter par mail : obercom@ober-surfaces.com"
  //   &lt;br/&gt;
},
  contact: {
    contactTitle: "Contactez-nous",
    firstname:"Prénom*",
    name:"Nom*",
    company:"Entreprise*",
    activity:"Activité*",
    address:"Adresse*",
    postCode:"Code postal*",
    city:"Ville*",
    country:"Pays*",
    phoneNumber:"Téléphone*",
    job:"Fonction*",
    emailAdress:"E-mail*",
    subjectMessage:"Sujet de votre message*",
    yourMessage:"Votre message*",
    sendButton:"Envoyer",
    fieldsRequired:"* Champs obligatoires",
    messageSending:"Envoi en cours",
    messageSent:"Votre message a bien été envoyé.",
    mapLanguage:"fr",
    headOffice:"Siège social",

    aaa:"",
    aaab:""
  },
  signup:{
    civility:"wazzaa",
    disconnect:"Se déconnecter",

    aaaq:"",
    aaas:""
  },
  signin:{
    connect:"Se connecter",
    introPage:"Vous devez vous connecter à votre compte <br />afin de <span class='font-bold'>sauvegarder</span> et <span class='font-bold'>télécharger</span> vos modèles.",
    noaccount:"Pas encore de compte ?",
    identify:"S'identifier",
    connectButton:"Se connecter",
    inscriptionButton:"Je m'inscris",
    emailAdressTextfield:"Adresse e-mail",
    passwordTextfield:"Mot de passe",
    forgottenPassword:"Mot de passe oublié"

  },
  userActivities:{
      activity0title: "Activité", // (not used anymore) Marques localisation => i18n
      activity1title: "Architecte",
      activity2title: "Architecte d’intérieur",
      activity3title: "Designer",
      activity4title: "Bureau d’étude",
      activity5title: "Entreprise générale",
      activity6title: "Promoteur",
      activity7title: "Menuisier / Agenceur",
      activity8title: "Economiste",
      activity9title: "Acousticien",
      activity10title: "Industriel",
      activity11title: "Maitre d’Ouvrage",
      activity12title: "Autre"
  },
  modals:{
    modifyMyFolder:"Modifier mon dossier",
    deleteFolderConfirmation:"Êtes vous sûr de vouloir supprimer ce dossier ?",
    deleteModelConfirmation: "Êtes vous sûr de vouloir supprimer ce modèle ?",
    deleteAccountConfirmation: "Êtes vous sûr de vouloir supprimer votre compte ?",
    shareModelTitle:"Partager votre composition",
    shareModelText:"Partager l'URL de votre composition :",
    shareModelCopyText:"Copier",
    shareModelCopiedText:"Copié",
    downloadModalTitle:"Téléchargement",
    downloadModalHDfile:"Images HD",
    downloadModalExportButton:"Exporter",
    downloadModalProductPerforatedSurface:"Surface perforée",
    downloadModalProductNonPerforatedSurface:"Surface non perforée",
    downloadModalProductPageButton:"Fiche technique",
    downloadModalGenerateButton:"Générer",
    downloadModalDownloadButton:"Télécharger",
    acousticPerformanceTitle:"Performance acoustique",

    welcomeModelTitle: "Bienvenue dans la page « mes modèles »!",
    welcomeModelText1: "Cet espace vous permet d’enregister et de télécharger vos modèles. Vous pourrez à tout moment organiser, modifier et supprimer vos créations.",
    welcomeModelText2: "Pour accéder à cette page, il vous suffit de cliquer sur « Mes modèles », situé à droite de votre barre de navigation.",

    addToExistingFolder:"Ajouter à un dossier existant",
    createNewFolder:"Créer un dossier pour enregistrer mon modèle",
    exArchitectForm:"Ex : Architecture divers"
  },
  account:{
    inscriptionPageTitle:"Inscription",
    civilitySign:"Civilité* :",
    civilityMrSign:"M.",
    civilityMrsSign:"Mme",
    lastNameSign:"Nom*",
    firstNameSign:"Prénom*",
    companyNameSign:"Entreprise*",
    addressSign:"Adresse*",
    citySign:"Ville*",
    postCodeSign:"Code postal*",
    countrySign:"Pays*",
    emailAddressSign:"Votre e-mail*",
    emailAddressConfirmSign:"Confirmation de votre e-mail*",
    passwordSign:"Votre mot de passe*",
    passwordConfirmSign:"Confirmation de votre mot de passe*",
    requiredSign:"* Champs obligatoires",
//my account
    disconnect:"Se déconnecter",
    deleteAccount:"Supprimer mon compte",
    newPasswordSign:"Nouveau mot de passe",
    newPasswordConfirmSign:"Confirmation nouveau mot de passe",
    emptyLabel:"Laisser vide si mot de passe non modifié",

  },
  pdf:{
    pdfLoading:"Chargement de l'export...",
    pdfLogoTitle:"Solutions acoustiques",
    pdfProductSpec:"Fiche produit",
    pdfProductRef:"Référence :",
    pdfLabelName:"Nom :",
    pdfLabelCompany:"Société :",
    pdfLabelFolderName:"Nom de dossier :",
    pdfLabelDate:"Date :",
    pdfLabelDescription:"Description",
    pdfLabelMaker:"Fabricant :",
    pdfLabelSurface:"Surface :",
    pdfLabelAcousticPerformance:"Perforation acoustique",
    pdfLabelSupport:"Support :",
    pdfLabelSupportMDF16:"MDF naturel 16 mm",
    pdfLabelContreface:"Contreface :",
    pdfLabelContrefaceVoileNoir: "Voile noir",
    pdfLabelSize:"Dimensions :",
    pdfLabelSizeContent:"standard 2490 x 1220 mm ou sur mesure",
    pdfLabelThickness:"Épaisseur totale :",
    pdfLabelFireClassification:"Classement au feu :",
    pdfLabelSurfaceResistance:"Résistance de surface :",
    pdfLabelSurfaceResistanceNorme:"conforme à la norme EN438",
    pdfLabelRegisteredDesign: "Modèle déposé Obersound",
    pdfLabelCustomSizes: "Dimensions sur mesure selon feuille de débit et plans",
    pdfLabelNB : "Surfaces non perforées disponibles sur demande.",
    pdfLabelAcouticPerf: "Performance acoustique",
    pdfLabelAcouticPerfAw: "\u03b1w :",
    pdfLabelPerforationRate: "Taux de perforation :",
    pdfLabelAvailableSoon: "Courbe acoustique bientôt disponible",
    pdfLabelMakerContact: "Contact fabricant",
    pdfLabelTechnicalSupport: "Support technique :",

  },
  editor:{
    introCreatePage:"Sélectionnez une surface <br />ou un motif pour commencer.",

    leftPanelSurfacesTitle:"Surfaces",
    RightPanelPatternsTitle:"Motifs",

    SurfacesFilter:"Filtrer ma recherche",
    SurfacesChange:"Modifier ma recherche",
    noSearchResult:"Aucun résultat ne correspond à vos critères de recherche",
    diameterLabel:"Diamètre",
    entraxeLabel:"Entraxe",

    brandIdFilter:"Marques :",
    brandIdFilterTitle1:"Oberflex",
    brandIdFilterTitle2:"Marotte",
    brandIdFilterTitle3:"Pure Paper Color",
    brandIdFilterTitle4:"Pure Paper Métal",

    typeIdFilter:"Types :",
    typeIdFilterTitle2:"Stratifiés bois",
    typeIdFilterTitle3:"Bois vernis",
    typeIdFilterTitle1:"Couleurs",
    typeIdFilterTitle4:"Metal",

    shadeIdFilter:"Nuances :",
    shadeIdFilterTitle1:"Clair",
    shadeIdFilterTitle2:"Moyen",
    shadeIdFilterTitle3:"Foncé",

    collectionIdFilter:"Collections :",
    collectionIdFilterTitle1:"Actions 5•5",
    collectionIdFilterTitle2:"Collections 5•5",
    collectionIdFilterTitle0:"Classiques",

    absorptionIdFilter:"Absorption acoustique :",
    absorptionIdFilterTitle1:"Moyenne",
    absorptionIdFilterTitle1Subtitle:"(aw 0,1 à 0,5)",
    absorptionIdFilterTitle2:"Forte",
    absorptionIdFilterTitle2Subtitle:"(aw 0,5 à 0,75)",
    absorptionIdFilterTitle3:"Forte +",
    absorptionIdFilterTitle3Subtitle:"(aw 0,75 à 0,95)",

    acousticPerformanceButton:"Courbe acoustique",
    acousticPerformanceLabel:"Courbe acoustique :",
    acousticPerformanceComingSoon:"Courbe acoustique bientôt disponible",

    PerforationRateLabel:"Taux de perforation :",

    validateButton:"Valider",
    validationMessage:"Votre modification a bien été enregistrée."
  }
};

/*
bbbb: {
  aaa:"",
  aaa:"",
  aaa:"",
  aaa:""
}

*/



// WEBPACK FOOTER //
// ./src/i18n/fr.js